import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Loading = () => (
  <div data-testid="auth-loading" className="flex min-h-[60vh] items-center justify-center font-mono text-xs uppercase text-zinc-500">
    Checking session&hellip;
  </div>
);

export const RequireAuth = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
};

export const RequireSubscription = () => {
  const { user, loading, isSubscribed } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isSubscribed) return <Navigate to="/subscribe" replace />;
  return <Outlet />;
};
